letterAdjust.scale = 0.85;
letterAdjust.x = 4.5;
var font = {
    ".": "M0,0h164v164H0V0z",
    "0": "M405.067 0h-277.112l-127.954 127.954v768.091l127.954 127.954h277.112l127.954-127.954v-768.091l-127.954-127.954zM364.121 825.671l-40.214 40.214h-114.61l-40.214-40.214v-627.342l40.214-40.214h114.61l40.214 40.214v627.342z",
    "1": "M209.114 1024v-1024h-168.9v825.671l-40.214 40.214v158.115z",
    "2": "M168.9 158.115v112.051l364.121 363.756v262.124l-127.954 127.954h-277.112l-127.954-127.954v-116.987h168.9v46.612l40.214 40.214h114.793l40.214-40.214v-121.374l-364.121-363.207v-341.090h533.021v158.115z",
    "3": "M454.024 511.991l79.025-79.007v-305.041l-127.925-127.943h-277.219l-127.906 127.943v116.993h168.964v-46.614l40.235-40.216h114.653l40.216 40.216v194.428l-40.216 40.198h-154.888v158.105h154.888l40.216 40.198v194.464l-40.216 40.216h-114.653l-40.235-40.216v-46.614h-168.964v116.956l127.906 127.943h277.219l127.925-127.943v-305.041l-79.025-79.025z",
    "4": "M533.021 403.056h46.612v-158.115h-46.612v-244.941h-168.9v244.941h-364.121v158.115l252.801 620.944h280.22v-620.944zM364.121 403.056v463.012l-188.641-463.012h188.641z",
    "5": "M168.9 865.885v-234.705l40.214-40.214h195.953l127.954-127.772v-335.24l-127.954-127.954h-277.112l-127.954 127.954v116.987h168.9v-46.612l40.214-40.214h114.793l40.214 40.214v194.308l-40.214 40.214-195.587-0.548-128.32 127.954v463.743h533.021v-158.115z",
    "6": "M364.121 779.059v46.612l-40.214 40.214h-114.61l-40.214-40.214v-234.522h236.167l127.954-127.954v-335.24l-127.954-127.954h-277.295l-127.954 127.954v768.091l127.954 127.954h277.112l127.954-127.954v-116.987h-168.9zM168.9 433.034v-234.705l40.214-40.214h114.61l40.214 40.214v194.491l-40.214 40.214h-154.825z",
    "7": "M533.021 1024v-158.115l-235.253-865.885h-175.48l235.253 865.885h-188.641v-86.826h-168.9v244.941z",
    "8": "M454.033 511.982l79.045-79.008v-305.010l-127.963-127.963h-277.151l-127.963 127.963v305.010l79.008 79.008-79.008 79.045v305.047l127.963 127.963h277.169l127.963-127.963v-305.047zM364.074 825.73l-40.217 40.217h-114.655l-40.217-40.217v-194.468l40.217-40.217h114.674l40.217 40.217zM364.074 392.738l-40.217 40.217h-114.655l-40.217-40.217v-194.431l40.217-40.217h114.674l40.217 40.217z",
    "9": "M168.9 244.941v-46.612l40.214-40.214h114.61l40.214 40.214v234.522h-235.984l-127.954 127.954v335.057l127.954 127.954h277.112l127.954-127.954v-767.909l-127.954-127.954h-277.112l-127.954 127.954v116.987h168.9zM364.121 590.966v234.705l-40.214 40.214h-114.61l-40.214-40.214v-194.491l40.214-40.214h154.825z",
    "A": "M412.035 158.278h-210.183l-32.681-158.278h-169.171l222.358 1024h169.171l222.358-1024h-169.171l-32.681 158.278zM379.354 315.915l-72.411 351.159-72.411-351.159h144.821z",
    "B": "M533.146 128.16l-128.16-128.16h-404.986v1024h404.986l128.16-128.16v-305.021l-78.819-78.819 78.819-78.819v-305.021zM363.975 825.992l-40.37 40.37h-154.433v-275.544h155.074l40.37 40.37v194.804zM363.975 392.811l-40.37 40.37h-154.433v-274.904h155.074l40.37 40.37v194.163z",
    "C": "M363.975 779.214v46.778l-40.37 40.37h-114.703l-39.73-40.37v-627.344l39.73-40.37h114.703l40.37 40.37v46.138h169.171v-116.626l-128.16-128.16h-276.826l-128.16 128.16v768.32l128.16 127.519h276.826l128.16-127.519v-117.267z",
    "D": "M404.986 0h-404.986v1024h404.986l128.16-128.16v-767.68l-128.16-128.16zM363.975 825.992l-40.37 40.37h-154.433v-708.085h155.074l40.37 40.37v627.344z",
    "E": "M0 0v1024h492.776v-157.637h-323.605v-275.544h194.804v-157.637h-194.804v-274.904h323.605v-158.278z",
    "F": "M169.171 865.722v-274.904h194.804v-157.637h-194.804v-433.181h-169.171v1024h492.776v-158.278z",
    "G": "M533.146 127.519l-128.16-127.519h-276.826l-128.16 127.519v768.32l128.16 128.16h276.826l128.16-128.16v-116.626h-169.171v46.138l-40.37 40.37h-114.063l-40.37-40.37v-627.344l40.37-40.37h114.063l40.37 40.37v235.174h-97.402v157.637h266.573z",
    "H": "M323.605 0v433.181h-154.433v-433.181h-169.171v1024h169.171v-433.181h154.433v433.181h169.171v-1024z",
    "I": "M0 0h169.171v1024h-169.171v-1024z",
    "J": "M492.776 1024v-896.481l-128.16-127.519h-236.456l-128.16 127.519v117.267h169.171v-46.778l39.73-40.37h74.974l39.73 40.37v825.992z",
    "K": "M533.080 0h-169.022l-157.041 432.935h-37.995v-432.935h-169.022v1024h169.022v-432.935h37.931l157.105 432.935h169.022l-185.745-512 185.745-512z",
    "L": "M169.171 158.278v865.722h-169.171v-1024h492.776v158.278z",
    "M": "M736.28 1024v-1024h-169.171v611.324l-141.617-506.233h-114.703l-141.617 506.233v-611.324h-169.171v1024h209.542l158.919-563.905 158.919 563.905z",
    "N": "M533.146 1024v-1024h-169.171l-194.804 573.517v-573.517h-169.171v1024h169.171l194.804-572.876v572.876z",
    "O": "M405.128 0h-276.984l-128.144 128.144v767.968l128.144 128.144h276.984l128.144-128.144v-767.968zM364.058 825.697l-40.237 40.237h-114.625l-40.237-40.237v-627.073l40.237-40.173h114.625l40.237 40.173z",
    "P": "M533.146 895.84v-413.957l-128.16-128.16h-235.815v-353.722h-169.171v1024h404.986l128.16-128.16zM363.975 825.352l-40.37 40.37h-154.433v-353.722h155.074l40.37 40.37v272.981z",
    "Q": "M512.925 161.522l-47.47-47.47 47.47-114.052h-162.755l-16.029 38.839h-210.842l-123.299 123.299v739.179l123.299 123.299h266.326l123.299-123.299v-739.795zM270.642 190.497l-16.029 38.839h96.173v603.55l-38.839 38.839h-110.353l-38.839-38.839v-602.933l38.839-38.839 69.048-0.616z",
    "R": "M533.146 481.882l-128.16-128.16 128.16-353.722h-168.531l-128.16 353.722h-67.284v-353.722h-169.171v1024h404.986l128.16-128.16v-413.957zM324.245 512l40.37 40.37v272.981l-40.37 40.37h-155.074v-353.722h155.074z",
    "S": "M363.975 779.214v46.778l-40.37 40.37h-114.063l-40.37-40.37v-194.804l40.37-39.73h195.444l128.16-128.16v-335.139l-128.16-128.16h-276.826l-128.16 128.16v116.626h169.171v-46.138l40.37-40.37h114.063l40.37 40.37v194.163l-40.37 40.37h-195.444l-128.16 127.519v335.78l128.16 127.519h276.826l128.16-127.519v-117.267z",
    "T": "M533.146 865.722h-181.987v-865.722h-169.171v865.722h-181.987v158.278h533.146z",
    "U": "M533.146 1024v-895.84l-128.16-128.16h-276.826l-128.16 128.16v895.84h169.171v-825.352l40.37-40.37h114.063l40.37 40.37v825.352z",
    "V": "M613.887 1024l-222.358-1024h-169.171l-222.358 1024h169.171l137.772-667.074 137.772 667.074z",
    "W": "M817.021 1024l-162.123-1024h-169.171l-77.537 530.583-76.896-530.583h-169.171l-162.123 1024h169.171l77.537-530.583 76.896 530.583h169.171l77.537-530.583 77.537 530.583z",
    "X": "M395.374 512l217.872-512h-176.861l-129.442 304.38-130.083-304.38h-176.861l217.872 512-217.872 512h176.861l130.083-303.74 129.442 303.74h176.861z",
    "Y": "M613.887 1024l-222.358-631.189v-392.811h-169.171v392.811l-222.358 631.189h169.171l137.772-415.88 137.772 415.88z",
    "Z": "M492.776 865.722l-315.274-707.444h315.274v-158.278h-492.776v158.278l315.915 707.444h-315.915v158.278h492.776z"
};
var font_size = 26.5,
    panel_Hor_Adjustment = 2.5,
    font_Top_Adjustment = -17.5,
    tracking = 1.5,
    middleSpreadAdjustment = {
        left: 1.25,
        right: 1.25
    },
    small_Caps_Adjustment = {
        vertical: -220,
        horizontal: 0,
        scale_width: 0, // this effects with the numbers
        scale_height: 0, // this effects with the numbers
    },
    // Colors are in order like this...  home: [ inside, outline, outline2, outline3 ]
    colors = {
        characters: {
            home: [
                "#FFFFFF", // white
            ],
            away: [
                "#00508F", // Blue
            ],
          	third: [
                "#ffffff", 
            ]
        },
        numbers: {
            home: [
                "#FFFFFF", // white
            ],
            away: [
                "#00508F", // Blue
            ],
          	third: [
                "#231f20", 
                "#ffffff", 
            ]
        }
    },
    outlines = {
        characters: {
            width: 0
        },
        numbers: {
            width: 1.5
        }
    },
    special_Character_Adjustments = {
        period: {
            vertical: 3, // this moves it up from the bottom
            horizontal: 0,
            scale_width: 31.5,
            scale_height: 31.5,
        },
        hyphen: {
            vertical: -8,
            horizontal: -5.5,
            scale_width: 0,
            scale_height: -3,
        },
        apostrophe: {
            vertical: -0.75, // this is backwards
            horizontal: -1,
            scale_width: 0,
            scale_height: 0,
        }
    },
    number_Adjustments = {
        top: 16,
        left: -4,
        width: 100,
        height: 85,
        middle_Space: 4,
        oneOffset: 7
    };